import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenu, MatMenuTrigger, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-rs-number-selection',
  templateUrl: 'rs-number-selection.component.html',
  styleUrl: 'rs-number-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatButton,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    TranslatePipe,
  ],
})
export class RsNumberSelectionComponent {
  private readonly userService = inject(UserService);
  protected readonly users = toSignal(this.userService.getAvailableUsers(), { initialValue: [] });
  private readonly router = inject(Router);

  public selectRsUser(user: User): void {
    this.userService.setCurrentUser(user);
    this.router.navigateByUrl(this.userService.getDefaultRedirectURL());
  }
}
